<template>
    <div>
        <VJoyLabel :text="$t('profile.section.header.name.label')"></VJoyLabel>
        <VJoyRadioGroup class="edit-display-option__radio-group" data-testid="profile-edition-section-headline-display-option">
            <VJoyRadio
                v-for="option in options"
                :key="option.value"
                v-model="model"
                :value="option.value"
                :data-testid="option.testid"
                theme="outline"
            >
                {{ option.label }}
            </VJoyRadio>
        </VJoyRadioGroup>
        <VJoyFormError v-if="errors.length" :errors="errors" data-testid="profile-edition-section-display-option-error" />
    </div>
</template>

<script setup lang="ts">
    import {VJoyLabel, VJoyFormError, VJoyRadioGroup, VJoyRadio} from '@maltjoy/core-vue';
    import type {NameDisplayOption} from '~/openapi';
    import {useProfileStore} from '~/store/profileStore';

    const model = defineModel<NameDisplayOption>({required: true});

    defineProps<{
        errors: string[];
    }>();

    const {displayNameWithOption} = useProfileStore();
    const options: {label: string; value: NameDisplayOption; testid: string}[] = [
        {
            label: displayNameWithOption('FULL'),
            value: 'FULL',
            testid: 'profile-edition-section-display-option-full',
        },
        {
            label: displayNameWithOption('INITIAL'),
            value: 'INITIAL',
            testid: 'profile-edition-section-display-option-initial',
        },
    ];
</script>

<style lang="scss" scoped>
    .edit-display-option {
        &__radio-group {
            :deep(.joy-radio-group-container) {
                flex-wrap: nowrap;
                margin-bottom: 0;
            }
        }
    }
</style>
